enum GroupState {
  NEW = "new",
  READIED_UP = "readied_up",
  RECEIVED_ALL_RESTAURANT_CATEGORY_PREFERENCES = "received_all_restaurant_category_preferences",
  RECEIVED_ALL_RESTAURANT_PREFERENCES = "received_all_restaurant_preferences",
}

export default GroupState;
